import {useCallback} from 'react'

import {ViewTypeParam} from '../../api/view/contracts'
import {ViewStateActionTypes} from '../../hooks/use-view-state-reducer/view-state-action-types'
import {useViews} from '../../hooks/use-views'

type UseTableHierarchy = {
  /** Whether or not the table should have hierarchy displayed or not */
  hierarchyEnabled: boolean
  /** Set the table hierarchy visibility state */
  setHierarchyEnabled: (viewNumber: number, enabled: boolean) => void
}

export const useTableHierarchy = (): UseTableHierarchy => {
  const {currentView, viewStateDispatch} = useViews()

  const enabled =
    currentView?.localViewState?.layout === ViewTypeParam.Table &&
    (currentView?.localViewState?.layoutSettings?.table?.hierarchy?.enabled ?? false)

  const setEnabled = useCallback(
    (viewNumber: number, newEnabled: boolean): void => {
      viewStateDispatch({
        type: ViewStateActionTypes.SetTableHierarchyEnabled,
        viewNumber,
        enabled: newEnabled,
      })
    },
    [viewStateDispatch],
  )

  return {
    hierarchyEnabled: enabled,
    setHierarchyEnabled: setEnabled,
  }
}
